import { Box } from '@chakra-ui/react';

type Props = {
  isUsed: boolean;
};

export const VisitBarSectionItem = ({ isUsed }: Props) => {
  return (
    <Box
      flex="1 1 auto"
      borderRadius={200}
      height={6}
      backgroundColor={isUsed ? 'success.700' : 'green.300'}
    />
  );
};
